
import { Component, Prop, Vue } from 'vue-property-decorator';
import { ValidationObserver } from 'vee-validate';

import SelectField from '../../../../../framework/fields/SelectField.vue';
import SwitchField from '../../../../../framework/fields/SwitchField.vue';
import TextField from '../../../../../framework/fields/TextField.vue';
import MonthField from '../../../../../framework/fields/MonthField.vue';

import { VehicleContract } from '../../../../../../common/application/model/VehicleContract';
import { apiPost } from '../../../../../../browser/framework/client';
import { ERROR_API_CALL_FAILED } from '../../../../../../common/framework/constants';

@Component({
    components: {
        SelectField,
        TextField,
        MonthField,
        ValidationObserver,
        SwitchField,
    },
})
export default class CopyVehicleContractWizard extends Vue {
    @Prop(Object) readonly selectedContract!: VehicleContract;

    local = {
        count: 1,
        loading: false,
    };

    // Functions
    async mounted() {}

    close(succeeded: boolean) {
        this.$emit(succeeded ? 'contractCopied' : 'close');
    }

    async submit() {
        const startTime = Date.now();
        this.local.loading = true;
        await this.copyAsDraft(this.selectedContract.id, this.local.count);
        await new Promise((resolve) => setTimeout(resolve, Math.max(0, 1000 - (Date.now() - startTime))));
        this.local.loading = false;
        this.close(true);
    }
    async copyAsDraft(
        vehicleContractId: string,
        count: number,
    ): Promise<
        (
            | { created: true; toSave: VehicleContract; saved: VehicleContract }
            | { created: false; toSave: VehicleContract; saved: null }
        )[]
    > {
        const response = await apiPost(`/api/admin/vehicle-contract/${vehicleContractId}/copy-as-draft`, { count });
        if (response.status === 200) {
            return await response.json();
        } else {
            throw new Error(ERROR_API_CALL_FAILED);
        }
    }
}
